import { render, staticRenderFns } from "./MeepIconMarge.vue?vue&type=template&id=545f834f"
import script from "./MeepIconMarge.vue?vue&type=script&lang=js"
export * from "./MeepIconMarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports